import { useParams } from "react-router";

import { LocationManagement as LocationManagementFeature } from "@/features/location-management/LocationManagement";

/**
 * Organization Location Management — view and edit locations, zones, and
 * sensors via map or list. Persists via Shadow APIs
 * (see docs/shadow-realm-map-migration.md).
 *
 * When `:locationId` is present, list and map are scoped to that location.
 */
export const LocationManagement = () => {
	const { locationId } = useParams();

	return (
		<div className="flex h-full min-h-0 flex-1 flex-col p-4 md:p-6">
			<LocationManagementFeature focusedLocationId={locationId} />
		</div>
	);
};
